import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { CurrentUser, User, UserSummary } from '../../../common/models/user';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatStepperModule } from '@angular/material/stepper';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Municipality, UpdateMunicipality } from '../../../common/models/municipality';
import { MunicipalityService } from '../../../common/services/municipality.service';
import { UsersComponent } from '../users/users.component';
import { UserService } from '../../../common/services/user.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-municipality-detail',
  templateUrl: './municipality.component.html',
  styleUrls: ['./municipality.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule,
    MatCardModule,
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatSelectModule
]
})
export class MunicipalityComponent implements OnInit {
  private destroy$ = new Subject<void>();

  isHandset: boolean = false;

  municipalityBasicInfoForm: FormGroup;

  isLoading: boolean = true;
  municipalityId!: string;

  users: UserSummary[] = [];

  user: CurrentUser | null = null;

  private readonly snackbarConfig: MatSnackBarConfig = {
    duration: 3000,
    horizontalPosition: 'right',
    verticalPosition: 'top'
  };


  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private userService: UserService,
    private municipalityService: MunicipalityService,
    private snackBar: MatSnackBar,
    private router: Router,
    private breakpointObserver: BreakpointObserver
  ) {

    // Step 1: Osnovni podaci
    this.municipalityBasicInfoForm = this.fb.group({
      name: [null, Validators.required],
      email: [null],
      telephone: [null],
      mobile: [null],
      users: [[]]
    });

  }

  ngOnInit(): void {
    this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).pipe(takeUntil(this.destroy$)).subscribe(result => {
      this.isHandset = result.matches;
    });

    this.loadUsers();

    const idParam = this.route.snapshot.paramMap.get('id');
    if (idParam) {
      this.municipalityId = idParam;
      this.loadMunicipality(this.municipalityId);
    } else {
      this.isLoading = false;
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private loadUsers() {
    this.userService.getUsers().pipe(takeUntil(this.destroy$)).subscribe({
      next: (users) => {
        this.users = users;
      },
      error: (err) => 
        console.error('Error loading roles', err)
    });
  }



  loadMunicipality(id: string) {
    this.municipalityService.getMunicipality(id).pipe(takeUntil(this.destroy$)).subscribe({
      next: (municipality: Municipality) => {
        this.municipalityBasicInfoForm.patchValue({
          name: municipality.name,
          email: municipality.email,
          telephone: municipality.telephone,
          mobile: municipality.mobile,
          users: municipality.users
        });
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error loading municipality', err);
        this.isLoading = false;
      }
    });
  }

  onSubmit() {
    this.updateMunicipality();
  }

  updateMunicipality() {
    if (this.municipalityBasicInfoForm.invalid) {
      this.snackBar.open('Molimo ispunite sva obavezna polja prije spremanja.', 'Zatvori', this.snackbarConfig);
      return;
    }

    const dto: UpdateMunicipality = {
      id: this.municipalityId,
      ...this.municipalityBasicInfoForm.value
    };

    this.municipalityService.updateMunicipality(dto).pipe(takeUntil(this.destroy$)).subscribe({
      next: () => {
        this.snackBar.open('Uspješno ste ažurirali podatke o Općini.', 'Zatvori', this.snackbarConfig);
        this.router.navigate(['administrator', 'municipalities']);
      },
      error: (error) => {
        console.error('Error updating municipality', error);
        this.snackBar.open('Greška prilikom ažuriranja Općine', 'Zatvori', this.snackbarConfig);
      }
    });
  }
}